import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/creative-commons-nc-eu': {
    width: 496,
    height: 512,
    paths: [
      {
        d: 'M247.7 8c140.7 0 248.3 109 248.3 248 0 147.1-118.1 248-248.3 248-136 0-247.7-111.7-247.7-248 0-131.2 103.6-248 247.7-248zM248.3 458.7c122.6 0 177.3-102.2 178.8-104.3l-128.3-56.8h-90.3c9.2 39.3 39.1 50.2 67.3 50.2 19.1 0 38.6-6.2 47.3-10.8l10 46.1c-14.2 7.9-38.2 15.8-64.8 15.8-57.4 0-113.2-34.3-124.6-101.3h-27v-29.5h22.8c0-16.3 0.4-13.3 0.4-19.5h-23.3v-29.5h4.7l-65.7-29.1c-7.2 20.8-10.9 42.8-10.9 66 0 110.2 91.6 202.7 203.6 202.7zM231.6 268.1l-0.5-0.4 0.9 0.4h-0.4zM308.8 248.6l136.1 60.5c4.2-16.6 6.3-34.2 6.3-52.9 0-113.2-90-203.4-203-203.4-13 0-106.1-3.2-170.7 93.6l81.6 36.1c4.1-7.2 8.6-14 13.9-20.1 23.7-26.5 56.9-42.3 95.9-42.3 25.3 0 47.3 5.8 62.3 12.4l-11.6 47.3c-10.8-4.6-27.8-10-46.1-10-20 0-38.2 6.6-51.1 22.4-3.4 3.8-6.3 8.8-8.8 14.3l28.6 12.6h70.3v29.5h-3.7z'
      }
    ]
  }
})
